import { render, staticRenderFns } from "./TransportPrice.vue?vue&type=template&id=6bfd3145&scoped=true"
import script from "./TransportPrice.vue?vue&type=script&lang=js"
export * from "./TransportPrice.vue?vue&type=script&lang=js"
import style0 from "./TransportPrice.vue?vue&type=style&index=0&id=6bfd3145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfd3145",
  null
  
)

export default component.exports